module.exports = __webpack_public_path__ + "static/homepage-page-1-4d804383baf9b9fd58aa3c1be4d4b2c2.jpg";